export enum PenaltyCode {
    COMPLETE_PENALTY = '100P',
    HALF_PENALTY = '50P',
    NO_PENALTY = '0P',
}
